import React, { useEffect, useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";
import { toWords } from "number-to-words";

export default function Commission_Invoice() {
    const { id } = useParams();
    const { token } = isAutheticated();
    const [invoice, setInvoice] = useState(null);
    const [loading, setLoading] = useState(false);

    const invoiceRef = useRef(null);

    const fetchInvoice = async () => {
        try {
            setLoading(true);
            const res = await axios.get(`${API}/api/invoices/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log("res", res.data)
            if (res.data.success) setInvoice(res.data.invoice);
        } catch (err) {
            console.error("Error fetching invoice:", err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInvoice();
    }, [id]);
    // const formatAmountInWords = (amount) => {
    //     if (!amount) return "";
    //     let words = toWords(amount); // e.g. "two thousand five hundred"
    //     // Capitalize each word
    //     words = words
    //         .split(" ")
    //         .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    //         .join(" ");
    //     return `${words} Only`;
    // };


    const formatAmountInWords = (amount) => {
        if (!amount || isNaN(amount)) return "";

        // 1. Split into whole number and decimals
        const mainPart = Math.floor(amount); // 154
        const centsPart = Math.round((amount - mainPart) * 100); // 84

        // 2. Helper to capitalize words (reusing your logic)
        const capitalize = (str) =>
            str.split(" ")
                .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                .join(" ");

        // 3. Convert main part to words
        let words = capitalize(toWords(mainPart));

        // 4. Add cents if they exist
        if (centsPart > 0) {
            const centWords = capitalize(toWords(centsPart));
            words += ` and ${centWords} Cents`;
        }

        return `${words} Only`;
    };
















    // const handlePrint = () => {
    //     if (!invoiceRef.current) return;
    //     const printWindow = window.open("", "_blank", "width=800,height=600");
    //     printWindow.document.write(`
    //   <html>
    //     <head>
    //       <title>Invoice</title>
    //       <style>
    //         body { font-family: Arial, sans-serif; padding: 20px; }
    //         table { width: 100%; border-collapse: collapse; }
    //         th, td { border: 1px solid #ddd; padding: 8px; }
    //         th { background: #f8f8f8; }
    //       </style>
    //     </head>
    //     <body>${invoiceRef.current.innerHTML}</body>
    //   </html>
    // `);
    //     printWindow.document.close();
    //     printWindow.focus();
    //     printWindow.print();
    // };
    const handlePrint = () => {
        if (!invoiceRef.current) return;

        const printWindow = window.open("", "_blank", "width=1000,height=700");

        printWindow.document.write(`
    <html>
      <head>
        <title>Invoice - AIOne SoComOTT</title>
        <style>
          body { font-family: Arial, sans-serif; padding: 20px; }
          .d-flex { display: flex; justify-content: space-between; align-items: flex-start; }
          .text-end { text-align: right; }
          .mb-4 { margin-bottom: 1rem; }
          .mb-5 { margin-bottom: 2rem; }
          .heading { text-align: center; font-size: 20px; font-weight: bold; margin-bottom: 30px; }

          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 8px; }
          th { background: #f8f8f8; }
          h4, h5 { margin: 0; padding: 0; }
          .small { font-size: 0.85rem; }
          .text-muted { color: #6c757d; }
          .fw-semibold { font-weight: 600; }
          .text-dark { color: #212529; }
        </style>
      </head>
      <body>
       
        <div>
          ${invoiceRef.current.innerHTML}
        </div>
      </body>
    </html>
  `);

        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
    };



    if (loading) return <p className="text-center mt-4">Loading invoice...</p>;
    if (!invoice) return <p className="text-center mt-4">Invoice not found.</p>;

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="container py-2">
                        <div className="d-flex justify-content-between align-items-end flex-end mb-3">
                            {/* <h2 className="mb-0">Invoice #{invoice.invoiceNumber}</h2> */}
                            <div>
                                <Link
                                    to={"/video_popup_click_commissions"}
                                    className="btn btn-secondary me-2"
                                >
                                    ← Back
                                </Link>
                                <button className="btn btn-primary" onClick={handlePrint}>
                                    🖨 Print
                                </button>
                            </div>
                        </div>

                        {/* Invoice Layout */}
                        <div className="card shadow p-4" ref={invoiceRef}>
                            <h3 className="text-center fw-bold" style={{ marginBottom: "40px" }}>
                                Invoice for {
                                    invoice.invoiceFor === "commission_Pay"
                                        ? (
                                            // If it's a commission, check who the payment is going TO
                                            invoice.payment_CommissionTo === "channel"
                                                ? "Channel Commission Payment"
                                                : invoice.payment_CommissionTo === "socom_Advisor"
                                                    ? "SoCom Advisor Commission Payment"
                                                    : "Network Channel Commission Payment"
                                        )
                                        : (
                                            // Fallback for Registration/Subscription
                                            invoice.invoiceFor === "channel" ? "Channel" : "Network Channel"
                                        )
                                }
                                {" "}
                                {
                                    invoice.type === "registration"
                                        ? "Registration Fee"
                                        : invoice.type === "subscription"
                                            ? "Subscription Fee"
                                            : "" // Empty for commission as we already added "Commission" above
                                }
                                {" "} on SoComOTT Platform
                            </h3>

                            {/* Invoice Info */}
                            <div className="row mb-4">
                                {/* Left side: Remit To */}
                                {/* <div className="col-md-6">
                                    <p><strong>Remit To:</strong></p>
                                    <p>
                                        AIOne, Inc<br />
                                        9 May St.<br />
                                        Dracut MA 01826
                                    </p>
                                    <p>Email: dave@aione.vc<br />Phone: 978-761-6348</p>
                                </div> */}
                                <div className="d-flex justify-content-between mb-4">
                                    {/* Left side: Remit To */}
                                    <div>
                                        <div><strong>Remit To:</strong></div>
                                        <div>
                                            AIOne, Inc<br />
                                            Attn: Dave Sackett<br />
                                            9 May St.<br />
                                            Dracut MA 01826
                                        </div>
                                        <div>Email: dave@aione.vc,<br />Phone: 978-761-6348</div>
                                    </div>

                                    {/* Right side: Invoice details */}
                                    <div className="text-end">
                                        {/* <div>
                                            <strong>
                                                Invoice No: </strong>
                                            payment_CommissionTo
                                            :
                                            "channel"
                                            {invoice?.invoiceFor === "channel"
                                                ? `AIOne/SoComOTT/${invoice.network_channelName}/${invoice.subchannelName}/${invoice.invoiceNumber}`
                                                : `AIOne/SoComOTT/${invoice.network_channelName}/${invoice.invoiceNumber}`}

                                        </div> */}
                                        <div className="text-end">
                                            <div>
                                                <strong>Invoice No: </strong>
                                                {invoice?.type === "commission_Pay"
                                                    ? `AIOne/SoComOTT/${invoice.payment_CommissionTo === "channel"
                                                        ? `${invoice.network_channelName}/${invoice.subchannelName}/`
                                                        : invoice.payment_CommissionTo === "socom_Advisor"
                                                            ? `${invoice.soComAdvisor_Name}/`
                                                            : ""
                                                    }${invoice.invoiceNumber}`

                                                    : invoice?.invoiceFor === "channel"
                                                        ? `AIOne/SoComOTT/${invoice.network_channelName}/${invoice.subchannelName}/${invoice.invoiceNumber}`
                                                        : `AIOne/SoComOTT/${invoice.network_channelName}/${invoice.invoiceNumber}`
                                                }
                                            </div>
                                        </div>
                                        <div>
                                            <strong>Dated:</strong>{" "}
                                            {invoice.createdAt
                                                ? new Date(invoice.createdAt).toLocaleDateString("en-US", {
                                                    month: "short",
                                                    day: "numeric",
                                                    year: "numeric",
                                                })
                                                : "-"}
                                        </div>
                                        <div className="mt-2">
                                            <strong>Status:</strong>{" "}
                                            <span
                                                style={{
                                                    fontSize: "1.3rem",
                                                    fontWeight: "bold",
                                                    padding: "4px 18px",
                                                    borderRadius: "30px",
                                                    color: "#fff",
                                                    background:
                                                        invoice.status === "paid"
                                                            ? "linear-gradient(90deg, #28a745 60%, #218838 100%)"
                                                            : "linear-gradient(90deg,#ffc107 60%,#ff9800 100%)",
                                                    display: "inline-block",
                                                    letterSpacing: "1px",
                                                    boxShadow: "0 2px 8px rgba(0,0,0,0.07)",
                                                }}
                                            >
                                                {invoice.status === "paid"
                                                    ? "Paid" : "Pending"}
                                            </span>
                                        </div>





                                    </div>
                                </div>
                                {/* Right side: Invoice details */}
                                {/* <div className="col-md-6 text-md-end">
                                    <p><strong>Invoice No:</strong>AIOne/SoComOTT/NetChannels/{invoice.invoiceNumber}</p>
                                    <p><strong>Dated:</strong> {invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString("en-GB") : "-"}</p>
                                </div> */}

                            </div>


                            {/* Bill To */}
                            {/* Bill To */}
                            <div className="mb-4">
                                <div className="row mb-3">
                                    <div className="col-8">
                                        <div><strong>Bill To:</strong></div>

                                        {/* 1. Case: Channel - Show Channel, Network, and Advisor details */}
                                        {invoice?.payment_CommissionTo === "channel" && (
                                            <>
                                                <div>
                                                    <span className="fw-semibold text-dark">Channel Name: </span>
                                                    {invoice?.subchannelName}
                                                </div>
                                                <div>
                                                    <span className="fw-semibold text-dark">Channel Administrator Name: </span>
                                                    {invoice?.subchannelId?.userID?.name}
                                                </div>
                                                <div>
                                                    <span className="fw-semibold text-dark">Channel Administrator Email: </span>
                                                    {invoice?.subchannelId?.userID?.email}
                                                </div>
                                                <div className="">
                                                    <strong>Network Channel Name:</strong> {invoice?.network_channelName} <br />
                                                    {/* <strong>SoCom Advisor:</strong> {invoice?.soComAdvisor_Name || "N/A"} */}
                                                </div>
                                            </>
                                        )}

                                        {/* 2. Case: Network Channel - Show Network and Advisor details */}
                                        {invoice?.payment_CommissionTo === "network_channel" && (
                                            <>
                                                <div>
                                                    <span className="fw-semibold text-dark">Network Channel Name: </span>
                                                    {invoice?.network_channelName}
                                                </div>
                                                <div>
                                                    <span className="fw-semibold text-dark">Network Channel Administrator Name:</span>
                                                    {invoice?.network_channelId?.userID?.name}
                                                </div>
                                                <div>
                                                    <span className="fw-semibold text-dark">Network Channel Administrator Email:</span>
                                                    {invoice?.network_channelId?.userID?.email}
                                                </div>
                                                {/* <div className="mt-2 text-muted small">
                                                    <strong>SoCom Advisor:</strong> {invoice?.soComAdvisor_Name || "N/A"}
                                                </div> */}
                                            </>
                                        )}

                                        {/* 3. Case: SoCom Advisor - Show only Advisor details */}
                                        {invoice?.payment_CommissionTo === "socom_Advisor" && (
                                            <>
                                                <div>
                                                    <span className="fw-semibold ">SoCom Advisor: </span>
                                                    {invoice?.soComAdvisor_Name}
                                                </div>
                                                {/* Assuming advisor object has contact info, adjust keys as per your schema */}
                                                <div>
                                                    <span className="fw-semibold ">SoComAdvisor Email: </span>
                                                    {invoice?.soComAdvisor_Id?.email || "N/A"}
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* Right side: Product details remains the same */}
                                    <div className="col-4 text-start">
                                        {invoice?.type === "commission_Pay" && invoice?.Product_popUp_clickId && (
                                            <div className="mt-">
                                                {/* <div className="mb-1"><strong>Product Details:</strong></div> */}
                                                <div className="">
                                                    <span className="fw-semibold text-dark">Click Serial No.:</span> {invoice.Product_popUp_clickId?.serialNumber || "N/A"}
                                                </div>
                                                <div className="">
                                                    <span className="fw-semibold text-dark">Product:</span> {invoice.Product_popUp_clickId?.productName}
                                                </div>

                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Terms Section in Table */}
                            {/* Terms Section in Horizontal Table */}
                            <table className="table table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th>Terms</th>
                                        <th>Immediate</th>
                                        <th>Due Date</th>

                                        <th>
                                            {invoice.dueDate
                                                ? new Date(invoice.dueDate).toLocaleDateString("en-US", {
                                                    month: "short",
                                                    day: "numeric",
                                                    year: "numeric",
                                                })
                                                : "-"}
                                        </th>

                                    </tr>
                                </thead>
                                {/* <tbody>
                                    <tr>
                                        <td>Immediate</td>
                                        <td>-------</td>

                                        <td>{invoice.dueDate ? new Date(invoice.dueDate).toLocaleDateString("en-GB") : "-"}</td>
                                        <td>{invoice.createdAt ? new Date(invoice.createdAt).toLocaleDateString("en-GB") : "-"}</td>
                                    </tr>
                                </tbody> */}
                            </table>



                            {/* Invoice Table */}
                            {/* <table className="table table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sl No</th>
                                        <th>Description</th>
                                        <th className="text-end">Amount (USD)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>1.</td>
                                        <td>
                                            AIOne – Network Channel{" "}
                                            {invoice.type === "registration"
                                                ? "Registration Fee"
                                                : "Monthly RENTAL fee"}{" "}
                                            on<br />SoComOTT Platform<br />
                                            <em>{formatAmountInWords(invoice.amount)}
                                            </em>
                                            <hr />
                                            <h5 style={{ textDecoration: "underline", textUnderlineOffset: "2px" }}>
                                                Corporate Bank Details For AIONE, INC.
                                            </h5>                                            <p>
                                                Employer Identification Number: 88-4083406<br />
                                                Beneficiary Account Name: AIONE, INC.<br />
                                                Bank Name: TD Bank, NA<br />
                                                Bank Address: PO BOX 1377, LEWISTON, ME 04240-1377<br />
                                                Phone: 877-898-7821<br />
                                                Account Number: 8262160620<br />
                                                Routing Number: 211370545<br />
                                                Federal ABA for Wires: 031101266<br />
                                                SWIFT Code: NRTHUS33XXX
                                            </p>
                                            <hr />
                                            <p className="text-muted small mt-4">
                                                This is a computer-generated invoice and does not require signatures.
                                            </p>
                                        </td>
                                        <td className="text-end">
                                            USD {invoice.amount?.toFixed(2)}

                                        </td>
                                    </tr>
                                </tbody>
                            </table> */}
                            <table className="table table-bordered">
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: "5%", verticalAlign: "top" }}>Sl No</th>
                                        <th style={{ width: "70%", verticalAlign: "top" }}>Description</th>
                                        <th style={{ width: "25%", verticalAlign: "top" }} className="text-end">
                                            Amount
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{ verticalAlign: "top" }}>1.</td>
                                        <td style={{ verticalAlign: "top" }}>

                                            AIOne – {

                                                invoice.invoiceFor === "commission_Pay"
                                                    ? (
                                                        // If it's a commission, check who the payment is going TO
                                                        invoice.payment_CommissionTo === "channel"
                                                            ? "Channel Commission Payment"
                                                            : invoice.payment_CommissionTo === "socom_Advisor"
                                                                ? "SoCom Advisor Commission Payment"
                                                                : "Network Channel Commission Payment"
                                                    )
                                                    : (
                                                        // Fallback for Registration/Subscription
                                                        invoice.invoiceFor === "channel" ? "Channel" : "Network Channel"
                                                    )
                                            }
                                            {" "}



                                            on SoComOTT Platform
                                            <br />
                                            {invoice.amount > 0 && (
                                                <>
                                                    <span>{invoice?.CurrencyCode ? invoice?.CurrencyCode : "USD"} </span>
                                                    <em>
                                                        <span className="fw-semibold text-dark">
                                                            {formatAmountInWords(invoice.amount)}
                                                        </span>
                                                    </em>
                                                </>
                                            )}

                                            {invoice.type === "subscription" && invoice.paidDate && invoice.dueDate && invoice.subscriptionStart && invoice.subscriptionEnd(
                                                <div>
                                                    (
                                                    <span className="fw-semibold text-dark">Subscription Period:</span>{" "}
                                                    ({
                                                        new Date(invoice.subscriptionStart).toLocaleDateString("en-US", {
                                                            month: "short",
                                                            day: "numeric",
                                                            year: "numeric",
                                                        })
                                                    } - {
                                                        new Date(invoice.subscriptionEnd).toLocaleDateString("en-US", {
                                                            month: "short",
                                                            day: "numeric",
                                                            year: "numeric",
                                                        })})
                                                </div>
                                            )}
                                            <hr />
                                            <h4
                                                style={{
                                                    textDecoration: "underline",
                                                    textUnderlineOffset: "2px",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                Corporate Bank Details For AIONE, INC.
                                            </h4>
                                            <p style={{ margin: 0 }}>
                                                <span className="fw-semibold text-dark">Employer Identification Number:</span> 88-4083406<br />

                                                <div>
                                                    <span className="fw-semibold text-dark">Here are the details to send money to AIOne:</span>
                                                </div>
                                                <span className="fw-semibold text-dark">Beneficiary Account Name:</span> AIONE, INC. <br />
                                                <span className="fw-semibold text-dark">Bank Name:</span> TD Bank, NA <br />
                                                <span className="fw-semibold text-dark">Bank Address:</span> PO BOX 1377, LEWISTON, ME 04240-1377 <br />
                                                <span className="fw-semibold text-dark">Phone:</span> 877-898-7821 <br />
                                                <span className="fw-semibold text-dark">Account Number:</span> 8262160620 <br />
                                                <span className="fw-semibold text-dark">Routing Number:</span> 211370545 <br />
                                                <span className="fw-semibold text-dark">Federal ABA for Wires:</span> 031101266 <br />
                                                <span className="fw-semibold text-dark">SWIFT Code:</span> NRTHUS33XXX
                                            </p>
                                            <hr />
                                            <p className="text-muted small mt-4">
                                                This is a computer-generated invoice and does not require signatures.
                                            </p>
                                        </td>
                                        <td style={{ verticalAlign: "top" }} className="text-end">
                                            {/* USD {invoice.amount?.toFixed(2)} */}
                                            {invoice?.CurrencyCode ? invoice?.CurrencyCode : "USD"} {invoice.amount.toFixed(2)}

                                        </td>
                                    </tr>
                                </tbody>
                            </table>



                            {/* Total */}
                            {/* <div className="d-flex justify-content-end mt-3">
                                <h4>Total: ${invoice.amount?.toFixed(2)}</h4>
                            </div> */}




                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
